import { useEffect, useState } from 'react';
import Home from './components/Home.jsx';
import Lesson from './components/Lesson.jsx';
import Settings from './components/Settings.jsx';
import Profile from './components/Profile.jsx';
import Phrases from './components/Phrases.jsx';
import Onboarding from './components/Onboarding.jsx';
import Splash from './components/Splash.jsx';
import SpeedRound from './components/SpeedRound.jsx';
import { useProgress, useDailyTick, shouldShowOnboarding } from './store/progress.js';

export default function App() {
  useDailyTick();
  const progress = useProgress();
  const [view, setView] = useState({ name: 'home' });
  const [settingsOpen, setSettingsOpen] = useState(false);
  const [onboarding, setOnboarding] = useState(() => shouldShowOnboarding());
  const [splash, setSplash] = useState(true);

  function startLesson(skill, lesson) {
    setView({ name: 'lesson', skill, lesson });
  }

  function startSpeedRound() {
    setView({ name: 'speed' });
  }

  function startStory(story) {
    setView({ name: 'story', story });
  }

  function handleTabChange(tabId) {
    if (tabId === 'home') setView({ name: 'home' });
    else if (tabId === 'phrases') setView({ name: 'phrases' });
    else if (tabId === 'profile') setView({ name: 'profile' });
  }

  function backToHome() {
    setView({ name: 'home' });
  }

  // Android hardware back button: close modal → back to home → exit app.
  useEffect(() => {
    function onBack(e) {
      if (settingsOpen) {
        e.preventDefault();
        setSettingsOpen(false);
      } else if (view.name !== 'home') {
        e.preventDefault();
        backToHome();
      }
    }
    window.addEventListener('ballingo:back', onBack);
    return () => window.removeEventListener('ballingo:back', onBack);
  }, [view, settingsOpen]);

  if (splash) {
    return <Splash onDone={() => setSplash(false)} />;
  }

  if (onboarding) {
    return <Onboarding onDone={() => setOnboarding(false)} />;
  }

  return (
    <>
      {view.name === 'home' && (
        <Home
          onStartLesson={startLesson}
          onStartSpeedRound={startSpeedRound}
          onStartStory={startStory}
          onOpenSettings={() => setSettingsOpen(true)}
          onTabChange={handleTabChange}
        />
      )}
      {view.name === 'speed' && (
        <SpeedRound onExit={backToHome} />
      )}
      {view.name === 'story' && (
        <Lesson story={view.story} onExit={backToHome} onComplete={backToHome} />
      )}
      {view.name === 'phrases' && (
        <Phrases
          onStartLesson={startLesson}
          onOpenSettings={() => setSettingsOpen(true)}
          onTabChange={handleTabChange}
        />
      )}
      {view.name === 'profile' && (
        <Profile
          onOpenSettings={() => setSettingsOpen(true)}
          onTabChange={handleTabChange}
        />
      )}
      {view.name === 'lesson' && (
        <Lesson
          skill={view.skill}
          lesson={view.lesson}
          onExit={backToHome}
          onComplete={backToHome}
        />
      )}
      {settingsOpen && <Settings onClose={() => setSettingsOpen(false)} />}
    </>
  );
}
